import React from 'react';

// Clicar num cartão aplica o filtro que já existe (Situação ou Status)
const CURSOS = [
  { chave: 'totalInstituicoes', nome: 'Cursos', descricao: 'cursos (curso + instituição + cidade) com os filtros atuais' },
  { chave: 'CONTATO OK', nome: 'Contato OK', cor: 'var(--cx-fec)', filtro: ['statusGrupo', 'Vinculado'], descricao: 'cursos vinculados: turma recente com negócio no Bitrix' },
  { chave: 'SEM CONTATO', nome: 'Sem contato', cor: 'var(--cx-vazio-borda)', filtro: ['statusGrupo', 'Livre'], descricao: 'cursos livres' }
];
const TURMAS = [
  { chave: 'EM NEGOCIAÇÃO', nome: 'Em negociação', cor: 'var(--cx-neg)', filtro: ['categoriaStatus', 'EM NEGOCIAÇÃO'], descricao: 'turmas de 2025 em diante em negociação no Bitrix' },
  { chave: 'FECHADOS', nome: 'Fechados', cor: 'var(--cx-fec)', filtro: ['categoriaStatus', 'FECHADOS'], descricao: 'turmas de 2025 em diante fechadas no Bitrix' },
  { chave: 'PERDIDO', nome: 'Perdidos', cor: 'var(--cx-per)', filtro: ['categoriaStatus', 'PERDIDO'], descricao: 'turmas de 2025 em diante perdidas no Bitrix' }
];

function valorDo(resumo, chave) {
  if (!resumo) return 0;
  if (chave === 'totalInstituicoes') return resumo.totalInstituicoes || 0;
  return (resumo.statusCounts && resumo.statusCounts[chave]) || 0;
}

function Cartao({ cartao, resumo, carregando, filtros, onFiltrar }) {
  const valor = resumo && resumo.erro ? '—' : valorDo(resumo, cartao.chave).toLocaleString('pt-BR');
  const conteudo = (
    <React.Fragment>
      <span className="cx-valor">
        {cartao.cor && <i style={{ background: cartao.cor }} />}
        {carregando ? '...' : valor}
      </span>
      <span className="cx-nome">{cartao.nome}</span>
    </React.Fragment>
  );
  const titulo = resumo && resumo.erro ? 'Não foi possível calcular os contadores agora' : `${valor} ${cartao.descricao}`;

  const cor = { '--cx-cor': cartao.cor || 'var(--cx-muted)' };
  if (!cartao.filtro) return <div className="cx-cartao" style={cor} title={titulo}>{conteudo}</div>;

  const [campo, valorFiltro] = cartao.filtro;
  const ativo = (filtros[campo] || []).indexOf(valorFiltro) >= 0;
  return (
    <button type="button" className="cx-cartao" style={cor} aria-pressed={ativo} title={`${titulo}. Clique para filtrar.`} onClick={() => onFiltrar(campo, valorFiltro)}>
      {conteudo}
    </button>
  );
}

export default function Cartoes(props) {
  return (
    <section className="cx-resumo" aria-label="Resumo">
      <div className="cx-grupo-cartoes">
        <h2>Cursos</h2>
        <div className="cx-cartoes">{CURSOS.map(c => <Cartao key={c.chave} cartao={c} {...props} />)}</div>
      </div>
      <div className="cx-grupo-cartoes">
        <h2>Turmas de 2025 em diante</h2>
        <div className="cx-cartoes">{TURMAS.map(c => <Cartao key={c.chave} cartao={c} {...props} />)}</div>
      </div>
    </section>
  );
}
